import dedent from 'ts-dedent'
import { ColumnDataType, Provider, WorkflowComponentParamType, WorkflowComponentCodeParams } from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class PolySplit extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'alteryx.polysplit',
        group: 'Data Preparation',
        title: 'Poly Split',
        description: `This component splits polygon or polyline objects into their component point, line, or region objects.`,
        tags: ['alteryx']
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'spatialfield',
          type: WorkflowComponentParamType.Column,
          title: 'Spatial Field',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'splitto',
          type: WorkflowComponentParamType.Selection,
          title: 'Split To',
          options: ['Points', 'Regions', 'Detailed Regions'],
          default: 'Points'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        if (params.splitto === 'Regions') {
          return dedent`
            WITH parts AS(
              SELECT ST_DUMP(${params.spatialfield}) dump, s.*
              FROM ${connection.quoteName(params.source as string)} s
            )
            SELECT Split_${params.spatialfield}, parts.* EXCEPT (dump)
            FROM parts, UNNEST (dump) split_${params.spatialfield}`
        } else if (params.splitto === 'Detailed Regions') {
          return dedent`
            WITH _parts AS(
              SELECT
                ST_DUMP(${params.spatialfield}) dump,
                s.*
              FROM ${connection.quoteName(params.source as string)} s
            ),
            _rings AS (
              SELECT ST_INTERIORRINGS(part) ring, _parts.* EXCEPT (dump)
              FROM _parts, UNNEST (dump) part
            )
            SELECT Split_${params.spatialfield}, _rings.* EXCEPT (ring)
            FROM _rings, UNNEST (ring) split_${params.spatialfield}
            UNION ALL
            SELECT
              ST_EXTERIORRING(part) Split_${params.spatialfield},
              _parts.* EXCEPT (dump)
            FROM _parts, UNNEST (dump) part
            `
        } else {
          return dedent`
            WITH parts AS(
              SELECT s.*,
              ST_DUMP(${params.spatialfield}) dump
              FROM ${connection.quoteName(params.source as string)} s
            ),
            linestrings AS(
              SELECT
              IF(CONTAINS_SUBSTR(ST_GEOMETRYTYPE(part), 'Polygon'),
                ST_EXTERIORRING(part),
                part
              ) AS _geometry, parts.* EXCEPT (dump)
              FROM parts, UNNEST (dump) part
            )
            SELECT
              ST_POINTN(_geometry, idx) Split_${params.spatialfield},
              linestrings.* EXCEPT (_geometry)
            FROM linestrings,
            UNNEST(GENERATE_ARRAY(1,ST_NUMPOINTS(_geometry))) idx`
        }
      default:
        return null
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery]
  }
}

export { PolySplit }
